import React from 'react';
import { Link } from 'react-router-dom';
import { useEvents } from '../context/EventContext_supabase';

const Home = () => {
  const { events } = useEvents();

  // Get upcoming events (future dates)
  const upcomingEvents = events.filter(event => {
    const eventDate = new Date(event.date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return eventDate >= today;
  }).slice(0, 3);

  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  // Format price to show 'FREE' for 0 or '0'
  const formatPrice = (price) => {
    if (!price || price === '0' || price === 0 || price === 'FREE') {
      return 'FREE';
    }
    return price;
  };

  // Sort artists function - bands first, then DJs
  const sortArtists = (artists) => {
    if (!artists) return [];
    return [...artists].sort((a, b) => {
      const typeOrder = { 'Band': 1, 'Artist': 2, 'Producer': 3, 'DJ': 4 };
      return (typeOrder[a.type] || 5) - (typeOrder[b.type] || 5);
    });
  };

  return (
    <div className="page-container" style={{ padding: 0, maxWidth: 'none', overflow: 'hidden' }}>

      
      <section style={{
        position: 'relative',
        overflow: 'hidden',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
      }}>
        {/* Video Background with Image Fallback */}
        <video 
          autoPlay 
          loop 
          muted 
          playsInline
          poster="/assets/images/vibrate-la-1920-1080.png"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 0
          }}
          onError={(e) => {
            // If video fails to load, hide video and show background image instead
            e.target.style.display = 'none';
            e.target.parentElement.style.backgroundImage = 'url(/assets/images/vibrate-la-1920-1080.png)';
            e.target.parentElement.style.backgroundSize = 'cover';
            e.target.parentElement.style.backgroundPosition = 'center';
            e.target.parentElement.style.backgroundRepeat = 'no-repeat';
          }}
        >
          <source src="/assets/videos/vibrate-la-1920-1080.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        
        
        <div style={{
          position: 'relative',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: 'white',
          padding: '0 1rem'
        }}>
          <img 
            src="/vibrate-logo-round.png" 
            alt="Vibrate LA"
            style={{
              height: '160px',
              width: '160px',
              borderRadius: '50%',
              objectFit: 'cover',
              marginBottom: '1.5rem',
              filter: 'drop-shadow(0 0 20px rgba(255, 0, 128, 0.5))',
              position: 'relative',
              zIndex: 20
            }}
            onError={(e) => {
              e.target.style.display = 'none';
              const fallback = document.createElement('h1');
              fallback.textContent = 'VIBRATE LA';
              fallback.style.cssText = 'font-size: 3.5rem; font-weight: 900; background: linear-gradient(45deg, #ff0080, #7928ca); -webkit-background-clip: text; -webkit-text-fill-color: transparent; margin: 0 0 1rem 0; position: relative; z-index: 20;';
              e.target.parentNode.insertBefore(fallback, e.target.nextSibling);
            }}
          />
          <p style={{ 
            position: 'relative', 
            zIndex: 20, 
            textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
            fontSize: '1.2rem',
            fontWeight: '600',
            marginBottom: '2rem',
            color: 'white'
          }}>
            A NIGHT OF PUNK, ROCK N ROLL, GLAM, POWER POP & NEW WAVE
          </p>
          <Link 
            to="/events" 
            style={{
              position: 'relative',
              zIndex: 20,
              backgroundColor: 'rgba(0, 0, 0, 0.9)',
              color: '#00ff80',
              border: '3px solid #00ff80',
              padding: '1.2rem 2.5rem',
              textDecoration: 'none',
              fontWeight: 'bold',
              fontSize: '1.2rem',
              borderRadius: '8px',
              textTransform: 'uppercase',
              letterSpacing: '1px',
              boxShadow: '0 0 25px rgba(0, 255, 128, 0.7)',
              transition: 'all 0.3s ease',
              display: 'inline-block',
              cursor: 'pointer',
              textShadow: '0 0 15px rgba(0, 255, 128, 1)',
              backdropFilter: 'blur(5px)'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#00ff80';
              e.target.style.color = '#000000';
              e.target.style.boxShadow = '0 0 40px rgba(0, 255, 128, 1)';
              e.target.style.transform = 'translateY(-3px) scale(1.02)';
              e.target.style.textShadow = 'none';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.9)';
              e.target.style.color = '#00ff80';
              e.target.style.boxShadow = '0 0 25px rgba(0, 255, 128, 0.7)';
              e.target.style.transform = 'translateY(0px) scale(1)';
              e.target.style.textShadow = '0 0 15px rgba(0, 255, 128, 1)';
            }}
          >
            Explore Events
          </Link>
        </div>
      </section>

      {/* Upcoming Events Section */}
      <section className="upcoming-events" style={{ textAlign: 'center', padding: '4rem 2rem', margin: '2rem 0' }}>
        <h2 style={{ color: '#00ff80', marginBottom: '3rem', fontSize: '2.5rem', fontWeight: 'bold' }}>Upcoming Events</h2>
        {upcomingEvents.length > 0 ? (
          <div className="events-grid">
            {upcomingEvents.map(event => (
              <div key={event.id} className="event-card">
                <img 
                  src={event.image_url || event.image} 
                  alt={event.title}
                  className="event-image"
                  onError={(e) => {
                    console.log('Image failed to load:', e.target.src);
                    e.target.src = 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=800&h=600&fit=crop';
                  }}
                />
                <div className="event-content">
                  <h3>{event.title}</h3>
                  <p className="event-date">{formatDate(event.date)}</p>
                  <p className="event-venue">{event.venue}</p>
                  <div className="event-details">
                    <span className="event-price">{formatPrice(event.price)}</span>
                    {event.artists && event.artists.length > 0 && (
                      <div className="event-artists">
                        <strong>Lineup:</strong>
                        <div className="artist-list">
                          {sortArtists(event.artists).slice(0, 3).map((artist, index) => (
                            <span key={index} className="artist-tag">
                              {artist.name}
                            </span>
                          ))}
                          {event.artists.length > 3 && (
                            <span className="more-artists">
                              +{event.artists.length - 3} more
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <Link 
                    to="/events" 
                    className="event-link"
                    style={{
                      backgroundColor: 'transparent',
                      color: '#00ff80',
                      border: '1px solid #00ff80',
                      padding: '0.5rem 1rem',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      fontSize: '0.9rem',
                      borderRadius: '4px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      boxShadow: '0 0 10px rgba(0, 255, 128, 0.3)',
                      transition: 'all 0.3s ease',
                      display: 'inline-block',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#00ff80';
                      e.target.style.color = '#000000';
                      e.target.style.boxShadow = '0 0 15px rgba(0, 255, 128, 0.6)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent';
                      e.target.style.color = '#00ff80';
                      e.target.style.boxShadow = '0 0 10px rgba(0, 255, 128, 0.3)';
                    }}
                  >
                    Learn More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '3rem', color: '#ccc' }}>
            <p>No upcoming events at the moment. Check back soon!</p>
          </div>
        )}
      </section>
    </div>
  );
};

export default Home;
